class TabComponent extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll(`.td-tabs__tab`);
    this.buttons = this.querySelectorAll(`.td-tabs__selector`);
  }

  connectedCallback() {
    if (this.tabs.length && this.buttons.length) {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Custom event for tab activation
    // Each selector button has its matching tab and CTA ids set in its data-attributes
    // On click matching elements gain the active class and all others lose the active class
    this.addEventListener('activate-tab', (e) => {
      const { detail } = e;
      this.tabs.forEach(tab => {
        tab.classList.toggle('active', tab.id === detail.tabId);
      });
      this.buttons.forEach(button => {
        button.classList.toggle('active', button.id === detail.buttonId);
      });
      this.ctas.forEach(cta => {
        cta.classList.toggle('active', cta.id === detail.ctaId);
      });
    });

    this.buttons.forEach(button => {
      button.addEventListener("click", () => {
        this.dispatchEvent(new CustomEvent('activate-tab', {
          detail: {
            tabId: button.dataset.tab,
            buttonId: button.dataset.button,
            ctaId: button.dataset.cta
          }
        }));
      });
    });
  }
}

customElements.define('td-tabs', TabComponent);
